import React from 'react'
import { compose, pure } from 'recompose'
import styles from './loadingBarComponent.scss'
import PropTypes from 'prop-types'
export function LoadingBar (props) {
  const { percentDone = 0 } = props
  const clampedPercentDone = Math.max(Math.min(percentDone, 100), 0)
  return (
    <div className={[styles.container].join(' ')}>
      <div
        className={[styles.indicator].join(' ')}
        style={{ width: clampedPercentDone + '%' }}
      />
    </div>
  )
}
LoadingBar.propTypes = {
  percentDone: PropTypes.number
}

export default compose(pure)(LoadingBar)



// WEBPACK FOOTER //
// ./src/components/loadingBar/loadingBarComponent.js